import { cn } from '@latitude/token-utils';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Content for when the search returns no results.
 *
 * @component
 * @example
 * ```tsx
 * <CommandEmpty />
 * ```
 */
export const CommandEmpty = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof CommandPrimitive.Empty> & {
  ref?: Ref<ComponentRef<typeof CommandPrimitive.Empty>>;
}) => (
  <CommandPrimitive.Empty
    ref={ref}
    data-testid="action-list-empty"
    className={cn(
      [
        'flex',
        'items-center',
        'justify-center',
        'py-6',
        'text-center',
        'font-comp-action-list-medium-font-family',
        'font-comp-action-list-medium-font-size',
        'font-comp-action-list-medium-font-weight',
        'leading-font-comp-action-list-medium-line-height',
        'text-color-comp-action-list-strong-on-container-default',
        'min-w-[150px]',
        'min-h-[135px]',
      ],
      className,
    )}
    {...props}
  />
);

CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
